/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guide_Required_ErrorInputs */



/**
* | output |
* | --- |
* | "Style guide data is required" |
*
* @param {Iframe_Remote_Style_Guide_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_required_error = /** @type {((inputs?: Iframe_Remote_Style_Guide_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Donnees de guide de style requises")
	if (locale === "de") return /** @type {LocalizedString} */ ("Styleguide-Daten erforderlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sono richiesti i dati della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Необходимы данные руководства по стилю.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requieren datos de la guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需要提供样式指南数据。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドデータが必要です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड डेटा आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("São necessários dados do guia de estilo.")
	return /** @type {LocalizedString} */ ("Style guide data is required")
});